<template>
  <template v-if="cardLayout">
    <div class="bx-teaser-container bx-teaser-container--vod-epg-cards">
      <BroadcastCard v-for="pair in flattenedBroadcasts"
                     :key="pair.broadcast.originId"
                     :broadcast="pair.broadcast"
                     :channel="pair.channel"
                     :total-cards="flattenedBroadcasts.length" />
    </div>
  </template>

  <template v-else>
    <div v-for="(item, index) in epgData"
         :key="`${item.channel.originId}-${index}`"
         class="bx-epg-search__row"
         :class="{'bx-js--single-broadcast': item.broadcasts.length === 1}">
      <Channel v-if="viewMode !== 'channel'"
               :channel="item.channel"
               @click="trackEventInDataLayer('epg_channel_logo_click', { click_url: `${origin}${item.channel.url}` })" />
      <div>
        <Broadcast v-for="(broadcast, i) in sliceBroadcasts(item.broadcasts)"
                   :key="broadcast.originId"
                   :broadcast="broadcast"
                   @click="trackEventInDataLayer(i === 0 ? 'epg_program_click' : 'epg_upcoming_program_click', { click_url: `${origin}${broadcast.url}` })" />
      </div>
    </div>
  </template>
</template>

<script>
import Channel from './Channel.vue'
import Broadcast from './Broadcast.vue'
import BroadcastCard from './BroadcastCard.vue'
import { useEpgWidgetTracking } from '../../../../composables/use-epg-widget-tracking'

export default {
  components: {
    Channel,
    Broadcast,
    BroadcastCard
  },
  props: {
    epgData: {
      type: Array,
      default: () => []
    },
    viewMode: {
      type: String,
      default: 'overview' // or "channel"
    },
    // Topic pages (config.isThematic) show every broadcast as its own card instead of a channel-grouped list
    cardLayout: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    return useEpgWidgetTracking()
  },
  data () {
    return {
      origin: null
    }
  },
  computed: {
    // one entry per broadcast (paired with its channel) instead of channel-grouped rows, used for the card layout
    flattenedBroadcasts () {
      return this.epgData.flatMap(item => item.broadcasts.map(broadcast => ({ channel: item.channel, broadcast })))
    }
  },
  beforeMount () {
    this.origin = window.location.origin
  },
  methods: {
    sliceBroadcasts (broadcasts) {
      if (broadcasts.length > 2) {
        console.warn('EpgSearch/BroadcastList.vue: more than two broadcasts available for channel')
      }
      // only show 2 broadcasts in overview mode
      return this.viewMode === 'overview' ? broadcasts.slice(0, 2) : broadcasts
    }
  }
}
</script>
